import {
  CREDIT_EXPERIAN_LOADING,
  CREDIT_EXPERIAN_SUCCESS,
  CREDIT_EXPERIAN_FAILED,
  SAVE_CREDIT_EXPERIAN_LOADING,
  SAVE_CREDIT_EXPERIAN_SUCCESS,
  SAVE_CREDIT_EXPERIAN_FAILED,
  VALIDATE_OTP_LOADING,
  VALIDATE_OTP_SUCCESS,
  VALIDATE_OTP_FAILED,
  SAVE_EXPERIAN_LOADING,
  SAVE_EXPERIAN_SUCCESS,
  SAVE_EXPERIAN_FAILED,
  PINCODE_CIBIL_LOADING,
  PINCODE_CIBIL_SUCCESS,
  PINCODE_CIBIL_FAILED,
  VERIFY_EXPERIAN_ANSWERS_LOADING,
  VERIFY_EXPERIAN_ANSWERS_SUCCESS,
  VERIFY_EXPERIAN_ANSWERS_FAILED,
} from "../Constants/creditExperianHistoryConstants";
export const creditExperianReducer = (
    state = { creditExperianData: [] },
    action
) => {
    switch (action.type) {
        case CREDIT_EXPERIAN_LOADING:
            return { loading: true, creditExperianData: [] };
        case CREDIT_EXPERIAN_SUCCESS:
            return { loading: false, creditExperianData: action.payload };
        case CREDIT_EXPERIAN_FAILED:
            return { loading: false, error: action.creditExperianData };
        default:
            return state;
    }
};

export const saveCreditExperianReducer = (
  state = { saveCreditExperianData: [] },
  action
) => {
  switch (action.type) {
    case SAVE_CREDIT_EXPERIAN_LOADING:
      return { loading: true, saveCreditExperianData: [] };
    case SAVE_CREDIT_EXPERIAN_SUCCESS:
      return { loading: false, saveCreditExperianData: action.payload };
    case SAVE_CREDIT_EXPERIAN_FAILED:
      return { loading: false, error: action.saveCreditExperianData };
    default:
      return state;
  }
};

const initialState = {
  question: '',
  banks: [],
  amounts: [],
  qid: '',
  loading: false,
  error: null,
};

export const questionAnswerReducer = (state = initialState, action) => {
  console.log(action, "actionquestion")
  switch (action.type) {
    case VERIFY_EXPERIAN_ANSWERS_LOADING:
      return { ...state, loading: true };
    case VERIFY_EXPERIAN_ANSWERS_SUCCESS:
      return {
        ...state,
        question: action.payload.question || '',
        banks: action.payload.banks || [],
        amounts: action.payload.amounts || [],
        qid: action.payload.qid || '',
        loading: false,
      };
    case VERIFY_EXPERIAN_ANSWERS_FAILED:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};

export const otpMatchExperianReducer = (
  state = { otpMatchExperianData: [] },
  action
) => {
  switch (action.type) {
    case VALIDATE_OTP_LOADING:
      return { loading: true, otpMatchExperianData: [] };
    case VALIDATE_OTP_SUCCESS:
      return { loading: false, otpMatchExperianData: action.payload };
    case VALIDATE_OTP_FAILED:
      return { loading: false, error: action.otpMatchExperianData };
    default:
      return state;
  }
}

export const saveExperianReducer = (
  state = { saveExperianData: [] },
  action
) => {
  switch (action.type) {
    case SAVE_EXPERIAN_LOADING:
      return { loading: true, saveExperianData: [] };
    case SAVE_EXPERIAN_SUCCESS:
      return { loading: false, saveExperianData: action.payload };
    case SAVE_EXPERIAN_FAILED:
      return { loading: false, error: action.saveExperianData };
    default:
      return state;
  }
}

export const getCityStateReducer = (
  state = { getCityStateData: [] },
  action
) => {
  switch (action.type) {
    case PINCODE_CIBIL_LOADING:
      return { loading: true, getCityStateData: [] };
    case PINCODE_CIBIL_SUCCESS:
      return { loading: false, getCityStateData: action.payload };
    case PINCODE_CIBIL_FAILED:
      return { loading: false, error: action.getCityStateData };
    default:
      return state;
  }
}